export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500/5 via-background-100 to-accent-500/5 rounded-3xl border border-background-200/40 p-8 md:p-12 lg:p-14">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
                移动追剧
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
                随时随地 畅享追剧
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-md mx-auto lg:mx-0 mb-6">
                红桃影视适配手机、平板等多种设备，支持离线缓存功能。通勤路上、午休时间、睡前放松，打开手机就能看。高清画质、流畅播放，让追剧不再受时间和地点限制。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm flex items-center justify-center gap-2"
                >
                  <i className="ri-smartphone-line"></i>手机端网页版
                </a>
                <a
                  href="#hero"
                  className="w-full sm:w-auto px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-background-200/60 flex items-center justify-center gap-2"
                >
                  <i className="ri-download-2-line"></i>了解更多
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-sm lg:max-w-none">
              <div className="relative mx-auto w-56 md:w-64">
                <div className="aspect-[9/16] bg-background-200 rounded-3xl border-4 border-background-300 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20mockup%20showing%20a%20modern%20Chinese%20TV%20drama%20streaming%20app%20interface%20with%20dark%20theme%2C%20drama%20poster%20thumbnails%2C%20clean%20UI%20design%2C%20cinematic%20color%20palette%20with%20warm%20red%20accents%2C%20minimalist%20layout%2C%20modern%20streaming%20platform%20design&width=600&height=1067&seq=app-mockup-2026-x1&orientation=portrait"
                    alt="红桃影视手机端界面展示"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -top-3 -right-3 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-500 text-background-50 shadow-sm">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}